import {
  LegacyAnalyticsEventData,
  ObjectActionEventProperties,
} from '../../analytics'
import { affiliations } from '../../helpers/analytics-utils/constants'
import { SegmentAnalyticsCall } from '../track-event'
import makeProductBaseProperties from './product-common'
import { transformObjectActionEventForSegment } from '.'

type CartProduct =
  | ObjectActionEventProperties['Cart']['Viewed']['products'][number]
  | ObjectActionEventProperties['Checkout Step']['Viewed']['products'][number]

const decimalPlaces = 2

export function transformLegacySendHitCheckout(
  data: Extract<LegacyAnalyticsEventData, { event: 'sendhitCheckout' }>
): SegmentAnalyticsCall {
  const cartAffiliation = affiliations.WESTFIELD_DIRECT_AU
  const currency = data.ecommerce.currencyCode

  // NOTE: product information will be the same for 'cart_viewed, fullfillment, payment'
  const cartProducts: CartProduct[] = data.ecommerce.checkout.products.map(
    product => {
      const cartProduct: CartProduct = {
        ...makeProductBaseProperties(product),
        currency,
        quantity: product.quantity,
      }

      if (product.category) {
        cartProduct.category_path = product.category

        const maxCategoryLimit = 5
        product.category
          .split(' / ')
          .forEach((category: string, index: number) => {
            if (index < maxCategoryLimit && category !== '') {
              const key = `category_${index + 1}` as const
              cartProduct[key] = category
            }
          })
      }

      return cartProduct
    }
  )

  const totalValue = Number(
    cartProducts
      .reduce(
        (total: number, product) =>
          total + (product.price ?? 0) * product.quantity,
        0
      )
      .toFixed(decimalPlaces)
  )

  if (data.ecommerce.checkout.actionField.step === '1') {
    return transformObjectActionEventForSegment({
      object: 'Cart',
      action: 'Viewed',
      properties: {
        category: 'Ecommerce',
        label: 'cart_viewed',
        cart_id: data.cartId,
        cart_affiliation: cartAffiliation,
        products: cartProducts,
        value: totalValue,
        currency,
        tax: undefined,
      },
    })
  }

  return transformObjectActionEventForSegment({
    object: 'Checkout Step',
    action: 'Viewed',
    properties: {
      category: 'Ecommerce',
      label: 'checkout_step_viewed',
      cart_id: data.cartId,
      cart_affiliation: cartAffiliation,
      products: cartProducts,
      value: totalValue,
      currency,
      tax: undefined,
    },
  })
}
